module.exports = __webpack_public_path__ + "img/home-catalogo.d975b468.png";